import { FirebaseApp } from "@angular/fire";


export class TimeLogic {
}

export function handleTimeStrings(time: string) {
  if (time == null || time === 'null') {
    time = '0000';
  }
  time = `0000${time}`;
  time = time.substring(time.length - 4);
  const hours = `${time[0]}${time[1]}`;
  const mins = `${time[2]}${time[3]}`;
  return `${hours}:${mins}`
}
export function timePercentage(time: string) {
  let timeString = '';
  if (time.includes(':')) {
    timeString = time.split(':')[0] + time.split(':')[1];
  }
  else {
    if (time.length == 4) {
      timeString = time;
    }
    else if (time.length == 3) {
      timeString = '0' + time;
    }
    const timeZoneOffset = new Date().getTimezoneOffset();
    let hours = +timeString.substring(0, 2);
    const mins = +timeString.substring(2, 4);
    let localMinutes = `${-timeZoneOffset + mins}`;
    if (+localMinutes < 0) {
      localMinutes += 60;
      hours--;
    }
    else if (+localMinutes > 60) {
      const localHours = Math.floor(+localMinutes / 60);
      localMinutes = `${+localMinutes % 60}`;
      hours = hours + localHours;
    }
    localMinutes = localMinutes.toString().length == 1 ? '0' + localMinutes : localMinutes;
    timeString = `${hours}${localMinutes}`;
    const timeAsNumber = +localMinutes + hours * 60;
    const percentage = timeAsNumber / 1440;
    let per = percentage * 100;
    if ((+timeString >= 0 && +timeString <= 700) || (+timeString >= 2101 && +timeString <= 2359)) {
      per = per * 1.4166666666666666667;
    }
    else if (+timeString >= 701 && +timeString <= 2100) {
      per = per * 0.79166666666666666667;
    }
    return per;
  }

}

export let firebaseApp: FirebaseApp;
export function initializeFirebaseApp(app: FirebaseApp) {
  firebaseApp = app;
}
// export const firebaseConfig = {
//   apiKey: "AIzaSyB6FuSKOwpyHDbEOJEOyFTEPO8W6B8DFJ8",
//   authDomain: "test-itmd.firebaseapp.com",
//   projectId: "test-itmd",
//   storageBucket: "test-itmd.appspot.com",
//   messagingSenderId: "257139487789",
//   appId: "1:257139487789:web:7119159fb24857647534a4",
//   measurementId: "G-J2N1DXJF92"
// };
export const firebaseConfig = {
  apiKey: "AIzaSyAm0ekaiCPQphiExsltOMLEjmLTw5fUCL8",
  authDomain: "itmd-timesheet.firebaseapp.com",
  projectId: "itmd-timesheet",
  storageBucket: "itmd-timesheet.appspot.com",
  messagingSenderId: "1003220938174",
  appId: "1:1003220938174:web:bc34a6d54f520c88b49def",
  measurementId: "G-WV4QEYRGHT",
  vapidKey: 'BBahMT2evB4KuliTREvhs9x8YX4mOOxxJTJmF7uAKTa8U4Dw--iVontBq3vPx9DgWnm0NdB87InP59TV5WFDUyQ'
};
